import BottomAdvertisement from '../../components/BottomAdvertisement/BottomAdvertisement';
import MainCategoryHeader from '../MainCategoryHeader/MainCategoryHeader';
import CardWithoutBottomHeader from '../TeacherStudentClassroomCards/CardWithoutBottomHeader';
import './Subjects.scss';
import { GET_CHAT_INDICATION, GET_CLASSROOM_UPDATES, GET_SUBJECTS, GET_SUBJECTS_BY_CLASSROOM } from '../../pages/TeacherStudentClassroom/api/TeacherStudentClassroomQuery';
import { useLazyQuery } from '@apollo/client';
import ToasterWithMessage from '../toaster';
import { useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from '../../redux/app/hooks';
import { useLocation } from 'react-router-dom';
import Loader from '../Loader/Loader';
import { FETCH_POLICY, MYLIBRARY_TEXTS, PATH_ADDRESSES, SCHOOL_ADMIN, STUDENT_ROLE } from '../../utils/constants';
import { GET_CONFIGURED_SUBJECTS_CHATS } from '../../pages/CommonChats/api/ChatsQuery';
import { Advertisement, ScreenImages } from '../AdminRightSideAd/AdminRightSideAd';
import axios, { AxiosResponse } from 'axios';
import { AssignmentNode, EbookNode, GetChatCountResponse, GetClassroomUpdatesResponse, GetClassroomUpdatesVariables, LibraryNode, QuizNode } from '../../pages/TeacherStudentClassroom/types/TeacherStudentClassroom';
import { setChatTabIndication, setIndication, setTabIndication } from '../../redux/slices/indication';
import { getScreenDimensions } from '../../utils/helper';
import { logout, setSplashvisible } from '../../redux/slices/authSlice';
import { closeBottomAd } from '../../redux/slices/rightSideAd';


interface SubjectsType {
    sjId: string;
    sjName: string;
    sjOriginalName: string;
    subjectAvatarUrl: string | null;
    navigateLocation: string;
    sessionExists?: boolean;
    unreadMsgCount?:number;
    sjColorCode: string;
}
interface SubjectsProps {
  withoutHeader?: boolean;
  tabName?: string;
  handleLiveSession?: () => void;
  adimage ? : string[]
  imageLoader? :boolean;
}

const Subjects = ({ withoutHeader, tabName, handleLiveSession, adimage, imageLoader }: SubjectsProps) => {
  const [subjects, setSubjects] = useState<SubjectsType[]>();
  const role = useAppSelector((state) => state.auth.role);
  const { state } = useLocation();
  const selectedClassId = useAppSelector((state) => state?.auth?.selectedClassRoomId);
  const dispatch = useAppDispatch();
  const { error } = ToasterWithMessage();
  const selectedClassRoomId = useAppSelector((state) => state.auth.selectedClassRoomId);
  const [quizNodes, setQuizNodes] = useState<QuizNode[]>([]);
  const [assignmentNodes, setAssignmentNodes] = useState<AssignmentNode[]>([])
  const [librayNodes, setLibrayNodes] = useState<LibraryNode[]>([]);
  const [ebookNodes, setEbookNodes] = useState<EbookNode[]>([]);
  const adminselectedClassRoomId = useAppSelector((state) => state.CommonUpload.classroomId);
  const chatService = process.env.REACT_APP_COMMON_CHAT_SERVICE || 'WEBSOCKET';
  const isChime = chatService === 'CHIME';
  const showAdvertisement = useAppSelector((state) => state.rightSideAd.showBottomAd);

  const handleCloseAdvertisement = () => {
    dispatch(closeBottomAd());
  };

  // to get my library files
  const [getSubjects, { loading }] = useLazyQuery(GET_SUBJECTS, {
    fetchPolicy: FETCH_POLICY,
    onCompleted: (data) => {
      const updatedSubjects = data?.getConfiguredSubjects?.map((subject: any) => ({
        ...subject,
          navigateLocation: state?.title === 'E-Books' ?  role === SCHOOL_ADMIN ? "/admin-materials-upload/materials/ebooks/materials" : role === STUDENT_ROLE ? '/student-classroom/ebooks/materials' : '/teacher-classroom/ebooks/materials':
            state?.title === MYLIBRARY_TEXTS?.IMAGES_TEXT ? role === SCHOOL_ADMIN ? "/admin-materials-upload/materials/images/materials" : role === STUDENT_ROLE ? '/student-classroom/images/materials' : '/teacher-classroom/images/materials' :
            state?.title === MYLIBRARY_TEXTS?.SYNDICATED_VIDEOS_TEXT ? role === SCHOOL_ADMIN ? "/admin-materials-upload/materials/videos/materials" : role === STUDENT_ROLE ? '/student-classroom/videos/materials' : '/teacher-classroom/videos/materials' :
              tabName === "LiveClass" ? role === STUDENT_ROLE ? '/student-classroom/liveclass' : '/teacher-classroom/liveclass' :
              tabName === "Quiz" ? role === STUDENT_ROLE ? PATH_ADDRESSES?.STUDENT_CLASSROOM_QUIZ_PATH : PATH_ADDRESSES?.TEACHER_CLASSROOM_QUIZ_PATH :
              tabName === "Assignments" ? role === STUDENT_ROLE ? '/student-classroom/assignments' : '/teacher-classroom/assignments' :
              // tabName === 'Chats' ? role === STUDENT_ROLE ? '/student-classroom/chats' : '/teacher-classroom/chats' :
              state?.title === MYLIBRARY_TEXTS?.PODCAST_TEXT ? role === SCHOOL_ADMIN ? "/admin-materials-upload/materials/podcast/materials" : role === STUDENT_ROLE ? '/student-classroom/podcast/materials' : '/teacher-classroom/podcast/materials' :  PATH_ADDRESSES?.TEACHER_CLASSROOM_PATH
      }));
      setSubjects(updatedSubjects);
    },
    onError: (err) => {
      error(err?.message);
    }
  });


  const [getSubjectsByClassrom, { loading:AdminLoading }] = useLazyQuery(GET_SUBJECTS_BY_CLASSROOM, {
    fetchPolicy: FETCH_POLICY,
    onCompleted: (data) => {
      const updatedSubjects = data?.allSubjects?.nodes?.map((subject: any) => ({
        ...subject,
          navigateLocation: state?.title === 'E-Books' ?  role === SCHOOL_ADMIN ? "/admin-materials-upload/materials/ebooks/materials" : role === STUDENT_ROLE ? '/student-classroom/ebooks/materials' : '/teacher-classroom/ebooks/materials':
            state?.title === MYLIBRARY_TEXTS?.IMAGES_TEXT ? role === SCHOOL_ADMIN ? "/admin-materials-upload/materials/images/materials" : role === STUDENT_ROLE ? '/student-classroom/images/materials' : '/teacher-classroom/images/materials' :
            state?.title === MYLIBRARY_TEXTS?.SYNDICATED_VIDEOS_TEXT ? role === SCHOOL_ADMIN ? "/admin-materials-upload/materials/videos/materials" : role === STUDENT_ROLE ? '/student-classroom/videos/materials' : '/teacher-classroom/videos/materials' :
              tabName === "LiveClass" ? role === STUDENT_ROLE ? '/student-classroom/liveclass' : '/teacher-classroom/liveclass' :
              tabName === "Quiz" ? role === STUDENT_ROLE ? PATH_ADDRESSES?.STUDENT_CLASSROOM_QUIZ_PATH : PATH_ADDRESSES?.TEACHER_CLASSROOM_QUIZ_PATH :
              tabName === "Assignments" ? role === STUDENT_ROLE ? '/student-classroom/assignments' : '/teacher-classroom/assignments' :
              // tabName === 'Chats' ? role === STUDENT_ROLE ? '/student-classroom/chats' : '/teacher-classroom/chats' :
              state?.title === MYLIBRARY_TEXTS?.PODCAST_TEXT ? role === SCHOOL_ADMIN ? "/admin-materials-upload/materials/podcast/materials" : role === STUDENT_ROLE ? '/student-classroom/podcast/materials' : '/teacher-classroom/podcast/materials' :  PATH_ADDRESSES?.TEACHER_CLASSROOM_PATH
      }));
      setSubjects(updatedSubjects);
    },
    onError: (err) => {
      error(err?.message);
    }
  });

  // to get my library files
  const [getChatSubjects, { loading: chatLoading }] = useLazyQuery(GET_CONFIGURED_SUBJECTS_CHATS, {
    fetchPolicy: FETCH_POLICY,
    onCompleted: (data) => {
      const updatedSubjects = data?.getConfiguredSubjectsForChat?.map((subject: any) => ({
        ...subject,
          navigateLocation:tabName === 'Chats' ? role === STUDENT_ROLE ? '/student-classroom/chats' : '/teacher-classroom/chats' : PATH_ADDRESSES?.TEACHER_CLASSROOM_PATH
      }));
      setSubjects(updatedSubjects);
    },
    onError: (err) => {
      console.log("Error in getting chat subjects:", err.message);
    }
  });

  useEffect(() => {
    if(selectedClassId){
    if(tabName === 'Chats'){
      getChatSubjects ({
        variables: {
          cId: selectedClassId,
          messagingProvider: isChime ? 'CHIME' : 'WEBSOCKET'
        }
      });
    }else{
    getSubjects({
      variables: {
        cId: selectedClassId
      }
    });
  }
    if (handleLiveSession) {
      handleLiveSession();
    }
  }
    // dispatch(setSelectedSubjectId({ selectedSubjectId: '' }));
  }, [ tabName, selectedClassId]);


  useEffect(() => {
   if(role === SCHOOL_ADMIN){
     getSubjectsByClassrom({
      variables : {
        classroomId  : adminselectedClassRoomId
      }
     });
   }
  },[])


   //indication for quiz, assignments, mylibrary
   const [getClassRoomUpdates] = useLazyQuery<
   GetClassroomUpdatesResponse,
   GetClassroomUpdatesVariables
 >(GET_CLASSROOM_UPDATES,{
   fetchPolicy:FETCH_POLICY,
   onCompleted: (data) => {
    const { quiz, assignments, mylibrary, ebooks, isStudentHaveAccess } = data.getClassroomUpdates;
    if (role === STUDENT_ROLE && isStudentHaveAccess === false) {
      error("Your Access has been revoked!");
      setTimeout(() => {
        dispatch(logout());
        dispatch(setSplashvisible());
      }, 2000);
      return;
    }
    const quizCount = quiz.totalCount;
    const assignmentCount = assignments.totalCount;
    const quizNodes = quiz.nodes;
    const assignmentNodes = assignments.nodes;
    const myLibrayCount = mylibrary.totalCount
    const ebooksCount = ebooks.totalCount;
    const libaryNodes = mylibrary.nodes
    const ebookNodes = ebooks.nodes
  
    setQuizNodes(quizNodes); 
    setAssignmentNodes(assignmentNodes);
    setLibrayNodes(libaryNodes)
    setEbookNodes(ebookNodes)
  
    const hasQuiz = quizCount > 0;
    const hasAssignment = assignmentCount > 0;
    const hasMylibrary =  myLibrayCount > 0;
    const hasEbooks = ebooksCount > 0;
  
    // Set tab indication based on either quiz or assignment presence
    dispatch(setTabIndication(hasQuiz || hasAssignment || hasMylibrary || hasEbooks));
  
    // Update quiz and assignment indications
    dispatch(setIndication({ 
      quiz: hasQuiz, 
      assignment: hasAssignment, 
      myLibray: hasMylibrary || hasEbooks
    }));
  },
   onError: (err) =>{
     console.log(err.message)
   }
 });


 //indication for chat
 const [getIndicationChat] = useLazyQuery<
   GetChatCountResponse,
   GetClassroomUpdatesVariables
 >(GET_CHAT_INDICATION, {
   fetchPolicy: FETCH_POLICY,
   onCompleted: (data) => {
     const chatCount = data.getAllChatCount
     const hasChat = chatCount > 0
     dispatch(setChatTabIndication(hasChat))
     dispatch(
      setIndication({
        chat: hasChat,
      })
    );
   },
   onError: (err) =>{
    console.log(err.message)
  }
 });
 
    useEffect(() => {
      if (role === STUDENT_ROLE && selectedClassRoomId) {
        getClassRoomUpdates({
          variables: {
            cId: selectedClassRoomId ?? "",
          },
        });
        // if(schoolType !== VIRTUAL){
        getIndicationChat({
          variables: {
            cId: selectedClassRoomId ?? "",
            messagingProvider: isChime ? 'CHIME' : 'WEBSOCKET'
          },
        });
      // }
      }
    }, [
      tabName,
      getClassRoomUpdates,
      selectedClassRoomId,
      role,
      getIndicationChat,
    ]);
  
  const location = useLocation()
  const katonCms = process.env.REACT_APP_KATON_CMS_SITE;
  const [screenImages, setScreenImages] = useState<ScreenImages[]>([]);
  const [advertisements, setAdvertisement] = useState<string[]>([]);
  const [loader,setLoading] = useState<boolean>(false)
  const schoolType = useAppSelector((state) => state.auth.schoolType);
  const baseUrl = process.env.REACT_APP_FRONTEND_URL;

  useEffect(()=>{
   const handleAdvertisement = () => {
    const lowercaseScreen = (screen: string) => screen.toLowerCase();
    let ad: ScreenImages | undefined;
    const parts = location.pathname.split("/")[2];
      switch (parts) {
            case 'ebooks':
                ad = screenImages.find(ad => lowercaseScreen(ad.screen) === "ebooks");
                break;
            case 'images':
                ad = screenImages.find(ad => lowercaseScreen(ad.screen) === "images");
                break;
            case 'podcast':
                ad = screenImages.find(ad => lowercaseScreen(ad.screen) === "podcast");
                break;
            case 'videos':
                ad = screenImages.find(ad => lowercaseScreen(ad.screen) === "videos");
                break;
            default:
                ad = undefined;
                break;
        }
    if (ad) {
        setAdvertisement(ad.images);
    } else {
        setAdvertisement([]);
    }
};
  handleAdvertisement();
  },[location.pathname, screenImages])

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true)
      try {
        const response: AxiosResponse<Advertisement[]> = await axios.get(
          `${katonCms}/class_room_advertisement`,
          {
            headers: {
              "X-Hash-Key": process.env.REACT_APP_KATON_SITE_API_KEY,
            },
          }
        );
        const advertisements = response.data;
        const role = localStorage.getItem("role") || "";

        const schoolAdminScreens: Record<string, string[]> = advertisements
          .filter((ad: Advertisement) =>
            ad.categories
              .map((category) => category.toLowerCase())
              .includes(role)
          )
          .reduce((acc: Record<string, string[]>, ad: Advertisement) => {
            const { Screen, Image } = ad;
            if (!acc[Screen]) {
              acc[Screen] = [];
            }
            acc[Screen].push(`${katonCms?.split("/wp-json")[0]}${Image}`);
            return acc;
          }, {});

        const result: ScreenImages[] = Object.keys(schoolAdminScreens).map(
          (screen: string) => ({
            screen,
            images: schoolAdminScreens[screen],
          })
        );
        setScreenImages(result)
      } catch (error) {
        console.log(error);
      }finally {
        setLoading(false); // Stop the loader
      }
    };

    fetchData();
  }, []);


  const isActive = (sjId: string, location : string) => {
  let indication;
  if(tabName){
    switch(tabName) {
      case 'Quiz' : 
      indication = quizNodes.some(quiz => quiz.subjectId === sjId)
      break;
      case 'Assignments': 
      indication = assignmentNodes.some(assignment => assignment.subjectId === sjId)
      break;
    }
  }
  else {
    switch(location) {
      case 'ebooks' : 
      indication = ebookNodes.some(node => node.subjectId === sjId)
      break;
      case 'images': 
      const imageNode = librayNodes.find(node => node.lType === MYLIBRARY_TEXTS?.IMAGES_TEXT);
      indication = imageNode ? imageNode.subjectIds.includes(sjId) : false;
      break;
      case 'podcast': 
      const podcastNode = librayNodes.find(node => node.lType === MYLIBRARY_TEXTS?.PODCAST_TEXT);
      indication = podcastNode ? podcastNode.subjectIds.includes(sjId) : false;
      break;
      case 'videos': 
      const videoNode = librayNodes.find(node => node.lType === MYLIBRARY_TEXTS?.SYNDICATED_VIDEOS_TEXT);
      indication = videoNode ? videoNode.subjectIds.includes(sjId) : false;
      break;
    }
  }
    return indication
  };

  return (
    <div className={((location?.pathname === PATH_ADDRESSES?.TEACHER_CLASSROOM_PATH || location?.pathname === PATH_ADDRESSES?.STUDENT_CLASSROOM_PATH) && getScreenDimensions()?.isMobileScreen) ? withoutHeader === true ? 'dashboardsubjectsMainCtnNoHeader' : 'dashboardsubjectsMainContainer' : withoutHeader === true ? 'subjectsMainCtnNoHeader' : 'subjectsMainContainer'}>
      {withoutHeader !== true && <MainCategoryHeader navigateLocation={role === SCHOOL_ADMIN ? "/admin-materials-upload/materials" : role === STUDENT_ROLE ? PATH_ADDRESSES?.STUDENT_CLASSROOM_PATH : PATH_ADDRESSES?.TEACHER_CLASSROOM_PATH} />}
      {
        ((subjects === undefined) || (loading) || chatLoading || AdminLoading) ? <Loader bottom='130px' left={'50px'} />
          :
          (
            <div className={withoutHeader === true ? 'bodyCtnNoHeader' : 'bodyContainer'} >
              {
                (subjects && subjects?.length > 0) ?
                  <div className='subjectsContainer'>
                    {
                      subjects?.map((subject: SubjectsType, index: number) => (
                        <CardWithoutBottomHeader image={ subject?.subjectAvatarUrl ? baseUrl + subject?.subjectAvatarUrl : null } title={subject?.sjOriginalName ? subject?.sjOriginalName : 'Subject Name'} imageHeight={'100%'} imageWidth={'100%'} navigateLocation={subject?.navigateLocation} subId={subject?.sjId} keyValue={`${subject?.sjId}-${index}`} sessionActive={subject?.sessionExists ? subject?.sessionExists : false} tabName={tabName} unreadMsgCount={subject?.unreadMsgCount} backGroundColor={subject?.sjColorCode} active={isActive(subject.sjId, location.pathname.split("/")[2])}/>
                      ))
                    }
                  </div>
                  : <div className='noDataFoundStyle'>No data found</div>
              }
              
              { showAdvertisement && ((adimage && !imageLoader) ? <BottomAdvertisement adImage={adimage[0]} showcloseIcon={true} handlecloseAd={handleCloseAdvertisement} /> : <BottomAdvertisement adImage={advertisements[0]} showcloseIcon={true} handlecloseAd={handleCloseAdvertisement} /> )}

            </div>
          )
      }
    </div>
  )
}

export default Subjects
